const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const EMAIL_MAX_LENGTH = 254;

export const DIRECT_PAYER_EMAIL_REQUIRED_MESSAGE = "Escribe el correo de quien paga.";
export const DIRECT_PAYER_EMAIL_INVALID_MESSAGE = "Ese correo no es válido. Revísalo, por ejemplo: pagos@tuempresa.com.";

export function normalizeDirectPayerEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function directPayerEmailError(value: string): string | null {
  const email = normalizeDirectPayerEmail(value);
  if (!email) return DIRECT_PAYER_EMAIL_REQUIRED_MESSAGE;
  if (email.length > EMAIL_MAX_LENGTH || !EMAIL_RE.test(email)) return DIRECT_PAYER_EMAIL_INVALID_MESSAGE;
  return null;
}

export function parseDirectPayerEmail(value: unknown): { email: string | null } | { error: string } {
  if (value === undefined || value === null) return { email: null };
  if (typeof value !== "string") return { error: DIRECT_PAYER_EMAIL_INVALID_MESSAGE };
  const email = normalizeDirectPayerEmail(value);
  if (!email) return { email: null };
  const error = directPayerEmailError(email);
  return error ? { error } : { email };
}
